<template>
  <!-- Google MFA -->
  <F2gDialog
    :show="showModal"
    :title="titleLabel"
    showClose
    :showActions="lastStep"
    max-width="800"
    @close="$emit('closeModal')"
    @eventCancel="$emit('closeModal')"
  >
    <template slot="content">
      <v-stepper v-model="modalStep" :class="{ activateStyle: !activeMfa }">
        <v-stepper-header class="flex-row-center">
          <v-stepper-step
            v-if="!activeMfa"
            step="1"
            :complete="modalStep > 1"
            class="cursor-pointer"
            :color="'success'"
            @click="modalStep = 1"
          >
            {{ $t("common.downloadApp") }}
            <small>{{ $t("common.optional") }}</small>
          </v-stepper-step>

          <v-divider v-if="!activeMfa" />

          <v-stepper-step
            v-if="!activeMfa"
            step="2"
            :complete="modalStep > 2"
            class="cursor-pointer"
            :color="'success'"
            @click="modalStep = 2"
          >
            {{ $t("common.scanQR") }}<small>{{ $t("common.optional") }}</small>
          </v-stepper-step>

          <v-divider v-if="!activeMfa" />

          <v-stepper-step
            :step="activeMfa ? '1' : '3'"
            :complete="modalStep > 3"
            class="cursor-pointer"
            :color="'success'"
            @click="modalStep = 3"
          >
            {{ $t("common.validationCode") }}
          </v-stepper-step>
        </v-stepper-header>

        <!-- Step 1 -->
        <v-stepper-content v-if="!activeMfa" step="1">
          <div>
            <div class="h-full flex-col-center">
              {{ $t("common.downloadGoogleAuthenticator") }}
              <div class="flex-row-center my-4">
                <div class="imgWrapper">
                  <!-- img Google -->
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=es&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                  >
                    <img
                      class="w-full"
                      alt="Disponible en Google Play"
                      src="@/flit2go-web-core/assets/google-play-badge.png"
                    />
                  </a>
                </div>
                <div class="imgWrapper apple">
                  <!-- img Apple -->
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://apps.apple.com/es/app/google-authenticator/id388497605"
                  >
                    <img
                      class="w-full"
                      src="@/flit2go-web-core/assets/apple-store-badge.svg"
                      alt="Apple Store"
                    />
                  </a>
                </div>
              </div>
            </div>

            <!-- Botones -->
            <v-layout justify-end>
              <div class="flex-row-center">
                <v-btn class="rounded" color="primary" @click="modalStep = 2">{{
                  $t("common.continue")
                }}</v-btn>
              </div>
            </v-layout>
          </div>
        </v-stepper-content>

        <!-- Step 2-->
        <v-stepper-content v-if="!activeMfa" step="2">
          <div class="text-center mx-4">
            <div class="h-full flex-col-center">
              <div>
                {{ $t("common.scanQRCode") }}
              </div>
              <div class="flex-row">
                <v-flex xs5 class="px-4">
                  <div class="flex-row">
                    <QRCode
                      :text="qrData.url"
                      size="150"
                      class="my-4 ml-auto"
                    />
                  </div>
                </v-flex>
                <div class="flex-col-center text--md px-2">
                  {{ $t("common.qrCodeText") }}
                  <div class="flex-row">
                    <div
                      class="px-4 py-2 button-rounded text--bold"
                      style="width: fit-content; background-color: #efefef"
                    >
                      <span>{{ qrData.key }}</span>
                    </div>
                    <F2gIcon
                      class="downloadIcon cursor-pointer rounded-lg mx-2"
                      value="download"
                      :strokeWidth="3"
                      @click="downloadKey"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- Botones -->
            <v-layout justify-end>
              <div class="flex-row-right">
                <v-btn outlined class="rounded mr-2" @click="modalStep = 1">{{
                  $t("common.back")
                }}</v-btn>
                <v-btn
                  class="rounded ml-2"
                  color="primary"
                  @click="modalStep = 3"
                  >{{ $t("common.continue") }}</v-btn
                >
              </div>
            </v-layout>
          </div>
        </v-stepper-content>

        <!-- Step 3 -->
        <v-stepper-content :step="activeMfa ? '1' : '3'">
          <div>
            {{ $t("common.mfaCodeText") }}
            <div class="verificatorWrapper mx-auto">
              <mfaVerificator
                class="mt-5"
                @validateToken="(token) => $emit('validateToken', token)"
              />
            </div>
          </div>
        </v-stepper-content>
      </v-stepper>
    </template>
  </F2gDialog>
</template>

<script>
import QRCode from "vue-qr-generator";
import mfaVerificator from "@/flit2go-web-core/components/ui/mfaVerificator";

export default {
  name: "mfaGooglePopUp",
  components: { QRCode, mfaVerificator },
  props: {
    showModal: { required: true, type: Boolean, default: false },
    qrData: { required: true, type: Object },
    activeMfa: { required: true, type: Boolean, default: true },
  },
  data: () => ({
    modalStep: 0,
  }),
  created() {
    this.modalStep = 1;
  },
  computed: {
    titleLabel() {
      return this.activeMfa
        ? this.$t("common.desactivateGoogleMfa")
        : this.$t("common.activateGoogleMfa");
    },
  },
  methods: {
    downloadKey() {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(this.qrData.key)
      );
      element.setAttribute("download", "authenticatorKey.txt");
      element.style.display = "none";

      document.body.appendChild(element);
      element.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.imgWrapper {
  width: 12rem;
}
.apple {
  padding: 12px 20px;
}
.activateStyle .v-stepper__wrapper {
  height: 17rem;
}

.v-stepper__wrapper > div {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.verificatorWrapper {
  width: 28rem;
}
.downloadIcon:hover {
  transition-duration: 500ms;
  transition-property: background-color;
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
